module.exports = __webpack_public_path__ + "static/media/IMG_4311.69f00507.JPG";